import { ValidationResult } from "./validation.types.ts";

export const flattenErrors = (result: ValidationResult): string[] => {
  const errors: string[] = [];
  Object.values(result).forEach(value => {
    if (value && typeof value === "object") {
      errors.push(...flattenErrors(value as ValidationResult));
    }

    if (value && typeof value === "string") {
      errors.push(value);
    }
  });

  return errors;
};
